module.exports = __webpack_public_path__ + "static/media/peacechild-beta-01.1b37fd89.svg";